var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDragUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 82,
    viewBox: "0 0 126 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2185_8966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5079 33.9812C87.371 28.2196 84.2691 23.0315 79.7318 19.3029C75.1946 15.5744 69.5037 13.5368 63.631 13.5381C53.8495 13.5381 45.3541 19.0889 41.1233 27.2119C36.1487 27.7495 31.5483 30.1065 28.2059 33.8299C24.8635 37.5534 23.015 42.3807 23.0156 47.3842C23.0156 58.5873 32.1202 67.6919 43.3233 67.6919H87.3233C96.6648 67.6919 104.246 60.1104 104.246 50.7689C104.246 41.8335 97.3079 34.5904 88.5079 33.9812ZM70.4002 43.9996V57.5381H56.8618V43.9996H46.7079L63.631 27.0765L80.5541 43.9996H70.4002Z",
    fill: "#333333",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.98 22.5628H110.564V27.9782H108.759V22.5628H103.344V20.7577H108.759V15.3423H110.564V20.7577H115.98V22.5628Z",
    fill: "#333333",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.524 60.245H118.462V64.3065H117.108V60.245H113.047V58.8911H117.108V54.8296H118.462V58.8911H122.524V60.245Z",
    fill: "#333333",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7234 23.0129H17.6003V31.136H14.8926V23.0129H6.76953V20.3052H14.8926V12.1821H17.6003V20.3052H25.7234V23.0129Z",
    fill: "#333333",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2185_8966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.2308,
    height: 81.2308,
    fill: "white",
    transform: "translate(23.0156)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragUpload);
export default __webpack_public_path__ + "static/media/dragUpload.5b04f0328d49fee200e3a73cac634588.svg";
export { ForwardRef as ReactComponent };